import React from 'react'
import './Aboutus.css'
import { Helmet } from "react-helmet-async";
function Aboutus() {
    return (
        <>

            <div className='about-us' id='about'>
                
                <h2>About us</h2>
            
            <div className='about-container'>

                <div className="about-card">

                    <div className="about-content">

                        <br />
                        <h3>Welcome to <strong>Nibhas HRD Solutions</strong></h3>,<br /> <br /> 
                         <h5> Nibhas HRD Solutions is a Job Consultancy and Recruitment Agency having specialization in 
                            doctors placement. We provide end to end all hiring solutions. We bridge the gap between the 
                            leading companies and the Career Aspirants. We act as a link between Companies that offer Jobs 
                            in various areas and the Job seekers. We also act as a guide to the Job searchers and help them
                             with their Career prospects.We have helped many professionals to have a successful career in 
                             Healthcare, Engineering Information Technology, Finance, Accounting, Construction, Hospitality, Administration, 
                             Management, Sales & Marketing, Marketing Research and many more.</h5>
                              <br />
                              
                    </div>
                </div>

            </div>
            </div>
            {/* <div className='about-title'>About</div>
            <div className='about'>
            <div class="about-card">
                <p>Welcome to <strong>Nibhas HRD Solutions</strong>,<br /> where talent meets opportunity. As a leading placement agency,
                 we take pride in revolutionizing the hiring experience for both employers and job seekers. Our commitment to excellence, personalized service, and a relentless
                 pursuit of the perfect match sets us apart in the competitive world of talent acquisition.</p>

            </div>
            </div> */}

        </>
    )
}

export default Aboutus


